import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { MongoDbLinkedService } from 'app/model/linkedservice/mongo-db.linkedservice';
import { MongoDbCopySource } from 'app/model/pipeline/copysource/mongo-db.copysource';
import { format } from 'app/shared/utils/string.util';
import { optionsTrueFalse } from 'app/registries/linked-service/linked-service-shared-fields';

export const mongoDbMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(MongoDbLinkedService).name,
    displayName: stringResources.MongoDb_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-MongoDBCollection'
    },
    tableNameAlias: 'collectionName',
    isFirstClass: true,
    tableColumnNameQuotes: ['"', '"'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(MongoDbCopySource).name],
    category: ['NoSQL'],
    timedQueryTemplate: 'select * from <<tableName>> \nwhere ' +
        '<<columnName>> >= {ts\'@{formatDateTime(pipeline().parameters.windowStart, \'yyyy-MM-dd HH:mm:ss\' )}\'} \nAND ' +
        '<<columnName>> < {ts\'@{formatDateTime(pipeline().parameters.windowEnd, \'yyyy-MM-dd HH:mm:ss\' )}\'}',
    notShowInTypeSelection: true,
    controls: [
        {
            type: 'textbox',
            bind: 'serverName',
            label: stringResources.ModelName_ServerName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'port',
            label: stringResources.ModelName_Port,
            isLabelVertical: true,
            inputType: 'number',
            min: 0,
            defaultValue: 27017
        },
        {
            type: 'textbox',
            bind: 'databaseName',
            label: stringResources.ModelName_DatabaseName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'select-switch',
            bind: 'authenticationType',
            label: stringResources.ModelName_AuthenticationType,
            options: [
                {
                    label: stringResources.Basic_DisplayText,
                    value: 'Basic'
                },
                {
                    label: stringResources.Anonymous_DisplayText,
                    value: 'Anonymous'
                }
            ],
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true,
            defaultValue: 'Basic',
            cases: [
                {
                    caseValue: 'Basic',
                    children: [
                        {
                            type: 'textbox',
                            bind: 'userName',
                            label: stringResources.ModelName_UserName,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true
                        },
                        {
                            type: 'dynamic-akv-switcher',
                            bind: 'password',
                            label: stringResources.ModelName_Password,
                            child: {
                                type: 'password',
                                label: stringResources.ModelName_Password,
                                required: true,
                                isLabelVertical: true
                            },
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                            format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MongoDb_DisplayText),
                                stringResources.ModelName_Password)
                        }
                    ]
                }
            ]
        },
        {
            type: 'textbox',
            bind: 'authSource',
            label: stringResources.ModelName_Authentication_Source,
            isLabelVertical: true,
            defaultValue: 'admin'
        },
        {
            type: 'radio',
            bind: 'enableSsl',
            label: stringResources.ModelName_EnableSSL,
            isLabelVertical: true,
            options: [
                {
                    label: stringResources.LinkedService_EnableSSL,
                    value: true
                },
                {
                    label: stringResources.LinkedService_DisableSSL,
                    value: false
                }
            ],
            defaultValue: false
        },
        {
            type: 'radio',
            bind: 'allowSelfSignedServerCert',
            label: stringResources.ModelName_AllowSelfSignedServerCert,
            isLabelVertical: true,
            options: optionsTrueFalse,
            defaultValue: false
        }
    ]
};
